<div class="bg-shui-base-3 border-0 border-l-4 border-solid border-[#FFD200] rounded-md">
    <div class="flex items-start gap-3 p-5">
        <sh-icon icon="warning" size="s" class="font-semibold"></sh-icon>
        <sh-text size="body-1" class="text-shui-text-strong max-w-[360px]">
            {{ 'common.action-required.multiple-pending-requests-action-required' | translate }}
        </sh-text>
    </div>
    <div class="px-5 pb-4">
        <sh-text size="body-2" class="text-shui-text-subtle">
            {{ 'common.action-required.multiple-escalated-requests' | translate }}
        </sh-text>
    </div>
    <div class="flex items-center justify-end p-5 pt-0 gap-2">
        @if (data.status !== EscalationStatus.SNOOZED) {
            <sh-button
                [label]="'common.action-required.remind-me-later' | translate"
                color="secondary"
                size="max-content"
                (click)="onRemindMeLater()"
            ></sh-button>
        }
        <sh-button
            [label]="'common.action-required.take-action' | translate"
            size="max-content"
            (click)="onTakeAction()"
        ></sh-button>
    </div>
</div>
